export enum EmployeeBenefitPermission {
  BenefitView = "product.employeeBenefit.benefit.view",
  BenefitUpdate = "product.employeeBenefit.benefit.update",
  PolicyView = "product.employeeBenefit.policy.view",
  PolicyViewCommissions = "product.employeeBenefit.policy.viewCommissions",
  PolicyAdd = "product.employeeBenefit.policy.add",
  PolicyUpdate = "product.employeeBenefit.policy.update",
  PolicyArchive = "product.employeeBenefit.policy.archive",
  PolicyExport = "product.employeeBenefit.policy.export",
  PlanView = "product.employeeBenefit.plan.view",
  PlanAdd = "product.employeeBenefit.plan.add",
  PlanUpdate = "product.employeeBenefit.plan.update",
  PlanDelete = "product.employeeBenefit.plan.delete",
  EmployeeView = "product.employeeBenefit.employee.view",
  EmployeeAdd = "product.employeeBenefit.employee.add",
  EmployeeEdit = "product.employeeBenefit.employee.edit",
  EmployeeUpload = "product.employeeBenefit.employee.upload",
  EmployeeDownload = "product.employeeBenefit.employee.download",
  EmployeeExportDataToInsurer = "product.employeeBenefit.employee.exportToInsurer",
  EmployeeDelete = "product.employeeBenefit.employee.delete",
  EmployeeActivate = "product.employeeBenefit.employee.activate",
  EmployeeApproveEdit = "product.employeeBenefit.employee.approveEdit",
  EmployeeAttachCardNumber = "product.employeeBenefit.employee.attachCardNumber",
  EmployeeTerminate = "product.employeeBenefit.employee.terminate",
  EmployeeTerminatePending = "product.employeeBenefit.employee.terminatePending",
  Socialization = "product.employeeBenefit.policy.socialization",
  SuperAdmin = "root",
}
